import { BROADCAST_CHANNELS, PaymentParams, PopupHandler, PopupWithBcHandler, randomId } from "@toruslabs/base-controllers";
import { post } from "@toruslabs/http-helpers";
import { JRPCEngine, SafeEventEmitter } from "@toruslabs/openlogin-jrpc";
import log from "loglevel";

import config from "@/config";

const postOrder = async (
  requestObject: { quote_id: string },
  headers: { Authorization: string }
): Promise<{ error: boolean; result: { bootstrapToken: string; paymentUrl: string } } | undefined> => {
  try {
    const options = {
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        ...headers,
      },
    };
    return post(`${config.topperApiHost}/topper/order`, requestObject, options as RequestInit);
  } catch (error) {
    log.error(error);
  }
  return undefined;
};

const getOrder = async (
  params: PaymentParams & { jwtToken?: string; address?: string; currentOrder?: { quote_id: string } },
  engine: {
    communicationEngine?: JRPCEngine;
    communicationWindowManager?: SafeEventEmitter;
  }
) => {
  const redirectUrl = new URL(`${config.redirect_uri}?preOpenedInstanceId=${randomId()}`);
  const preOpenedWindow = new PopupHandler({
    config: {
      target: "form-target",
    },
    state: { url: redirectUrl },
  });
  preOpenedWindow.open();
  preOpenedWindow.once("close", () => {
    throw new Error("user closed topper popup");
  });

  postOrder(
    {
      quote_id: params.currentOrder?.quote_id ?? "",
    },
    {
      Authorization: `Bearer ${params.jwtToken}`,
    }
  )
    .then(async (data) => {
      if (!data) return null;

      const { bootstrapToken, paymentUrl } = data.result;

      const form = document.createElement("form");
      form.method = "get";
      form.action = paymentUrl;
      form.target = "form-target";

      const hiddenField = document.createElement("input");
      hiddenField.type = "hidden";
      hiddenField.name = "bt";
      hiddenField.value = bootstrapToken;
      form.append(hiddenField);

      document.body.append(form);

      const topperWindow = new PopupWithBcHandler({
        state: {
          url: new URL("about:blank"),
          windowId: randomId(),
        },
        config: {
          dappStorageKey: config.dappStorageKey || undefined,
          communicationEngine: engine?.communicationEngine,
          communicationWindowManager: engine?.communicationWindowManager,
          target: "_blank",
        },
        instanceId: `${BROADCAST_CHANNELS.REDIRECT_CHANNEL}_${randomId()}`,
      });

      setTimeout(() => {
        form.submit();
      }, 1000);

      await topperWindow.handle();

      return null;
    })
    .catch((error) => {
      log.error(error);
    });
  return new URL(`${config.topperApiHost}`);
};

export default {
  getOrder,
};
